/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategyExecutionCustomFieldOption'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StrategyExecutionCustomFieldOption'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyExecutionCustomFieldReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategyExecutionCustomFieldOption);
  }
}(this, function(ApiClient, StrategyExecutionCustomFieldOption) {
  'use strict';




  /**
   * The StrategyExecutionCustomFieldReport model module.
   * @module model/StrategyExecutionCustomFieldReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyExecutionCustomFieldReport</code>.
   * @alias module:model/StrategyExecutionCustomFieldReport
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>StrategyExecutionCustomFieldReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyExecutionCustomFieldReport} obj Optional instance to populate.
   * @return {module:model/StrategyExecutionCustomFieldReport} The populated <code>StrategyExecutionCustomFieldReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Options')) {
        obj['Options'] = ApiClient.convertToType(data['Options'], [StrategyExecutionCustomFieldOption]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('IsGoalMilestoneField')) {
        obj['IsGoalMilestoneField'] = ApiClient.convertToType(data['IsGoalMilestoneField'], 'Boolean');
      }
      if (data.hasOwnProperty('IsStrategicProgramField')) {
        obj['IsStrategicProgramField'] = ApiClient.convertToType(data['IsStrategicProgramField'], 'Boolean');
      }
      if (data.hasOwnProperty('FieldTypeID')) {
        obj['FieldTypeID'] = ApiClient.convertToType(data['FieldTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('AskInStatusUpdate')) {
        obj['AskInStatusUpdate'] = ApiClient.convertToType(data['AskInStatusUpdate'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowInRoadmapRange')) {
        obj['ShowInRoadmapRange'] = ApiClient.convertToType(data['ShowInRoadmapRange'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/StrategyExecutionCustomFieldOption>} Options
   */
  exports.prototype['Options'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Boolean} IsGoalMilestoneField
   * @default false
   */
  exports.prototype['IsGoalMilestoneField'] = false;
  /**
   * @member {Boolean} IsStrategicProgramField
   * @default false
   */
  exports.prototype['IsStrategicProgramField'] = false;
  /**
   * @member {Integer} FieldTypeID
   * @default 0
   */
  exports.prototype['FieldTypeID'] = 0;
  /**
   * @member {Boolean} AskInStatusUpdate
   * @default false
   */
  exports.prototype['AskInStatusUpdate'] = false;
  /**
   * @member {Boolean} ShowInRoadmapRange
   * @default false
   */
  exports.prototype['ShowInRoadmapRange'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


